import { render } from "./UserCard.vue?vue&type=template&id=aeb9c6d4&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=aeb9c6d4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb9c6d4"]])

export default __exports__